import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../common/queryClient/getMutationFn';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { CalculateOutputDataType } from '../schema/types';

const postCalculateOutputData = async (
  request: CalculateOutputDataType,
  headers?: HttpHeaders,
) =>
  apiClient
    .post<void>(
      OutputDataUrl.OUTPUT_DATA_CALCULATION,
      request,
      headers ? { headers } : undefined,
    )
    .then((response) => response.data);

export const useCalculateOutputData = createApiMutationHook(
  ['calculateOutputData'],
  getMutationFn(postCalculateOutputData),
);
